import { useEffect, useRef, useState, type FormEvent } from 'react'
import './ProfileNameModal.css'

type Props = {
  open: boolean
  initialName?: string
  saving?: boolean
  error?: string | null
  onSubmit: (creatorName: string) => void
}

export default function ProfileNameModal({
  open,
  initialName = '',
  saving = false,
  error = null,
  onSubmit,
}: Props) {
  const dialogRef = useRef<HTMLDialogElement>(null)
  const [name, setName] = useState(initialName)

  useEffect(() => {
    const dlg = dialogRef.current
    if (!dlg) return
    if (open && !dlg.open) dlg.showModal()
    if (!open && dlg.open) dlg.close()
  }, [open])

  useEffect(() => {
    if (open) setName(initialName)
  }, [open, initialName])

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    const trimmed = name.trim()
    if (!trimmed || saving) return
    onSubmit(trimmed)
  }

  return (
    <dialog
      ref={dialogRef}
      className="profile-modal"
      // Block ESC: the user must enter a name to dismiss.
      onCancel={(e) => e.preventDefault()}
    >
      <form className="profile-modal__form" onSubmit={handleSubmit}>
        <h2 className="profile-modal__title">Welcome — what should we call you?</h2>
        <p className="profile-modal__lede">
          This is the creator name shown in the toy store next to anything you make.
        </p>

        <label className="profile-modal__field">
          <span className="profile-modal__label">Creator name</span>
          <input
            type="text"
            className="profile-modal__input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            autoFocus
            maxLength={80}
            disabled={saving}
          />
        </label>

        {error && <p className="profile-modal__error">{error}</p>}

        <div className="profile-modal__actions">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!name.trim() || saving}
          >
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </form>
    </dialog>
  )
}
